import { render, staticRenderFns } from "./createPrve.vue?vue&type=template&id=0b945a67&scoped=true"
import script from "./createPrve.vue?vue&type=script&lang=js"
export * from "./createPrve.vue?vue&type=script&lang=js"
import style0 from "./createPrve.vue?vue&type=style&index=0&id=0b945a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b945a67",
  null
  
)

export default component.exports